import React from "react";
import "./PopUp.css";
import PopUpForm from "./PopUpForm";
const PopUp = () => {
  return (
    <div className="popup-container">
      <PopUpForm />
    </div>
  );
};

export default PopUp;
